import { convertToTitleCase } from "@dirootie-extensions/javascript";
import { toTitleCase } from "@dirootie-toolbox/strings";
import { FILTER_TYPES } from "taltech-styleguide";

const getMaterialText = (material: string) => {
  if (material === "PAINTORCOATING") return "Paint/Coating";
  return toTitleCase(material);
};

export const colEnum = {
  classes: "w-10",
  dataField: "type",
  sort: true,
  text: "Type",
  formatter: (col: string) => getMaterialText(col),
};

export const colSourceType = {
  sort: false,
  text: "Source",
  classes: "w-10",
  dataField: "sourceType",
  formatter: (col: any) => {
    const sourceType = col === "USER" ? "Self" : col;
    return sourceType ? convertToTitleCase(sourceType) : "Unknown";
  },
  filterObject: {
    defaultValue: undefined,
    options: {
      USER: "Self",
      SYSTEM: "System",
    },
    placeholder: "Source",
    type: FILTER_TYPES.MULTISELECT,
  },
};

export const colCreationType = {
  dataField: "creationType",
  sort: false,
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return (
      <>
        {col.creationType === "RANDOM" ? (
          <img
            src={"/Random.svg"}
            alt={"success Shuffle"}
            style={{ opacity: 0.5 }}
            className={"ebd-shuffle-btn"}
          />
        ) : (
          <img
            src={"/Not_Random.svg"}
            alt={"success Shuffle"}
            style={{ opacity: 0.5 }}
            className={"ebd-shuffle-btn"}
          />
        )}
      </>
    );
  },
};

export const colSourceId = {
  hidden: true,
  sort: false,
  dataField: "sourceId",
};
